module.exports = __webpack_public_path__ + "img/img-warning-amount-ads-account.2aaa843d.png";